import Arrowleft from "../../../assets/icons/LeftArrowSimple.svg";
import ArrowRight from "../../../assets/icons/RightArrowSimple.svg";
import SimaoPhoto from "../../../assets/icons/Simao_Photo.svg";
import calendarphoto from "../../../assets/icons/Calendar_photo.svg";
import "./ManageAbsencesAdmin.css";

const AbsenceAdmin = () => {
  const pedidos = ["Simão", "João", "Ana", "Paulo", "Nuno", "Tomás"];

  return (
    <div className="container-fluid">
      <div className="row" style={{ height: "10rem" }}>
        <div className="col-12 col-md-8">
          <div className="row">
            {/* Arrow Left */}
            <div className="col-auto d-flex align-items-center pe-0">
              <div
                className="card border-0 rounded d-flex align-items-center justify-content-center"
                style={{
                  width: "100%",
                  height: "84%",
                  backgroundColor: "#0E46A3",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body d-flex justify-content-center align-items-center p-0">
                  <img
                    src={Arrowleft}
                    alt="Arrow left"
                    style={{ width: "1.5rem", height: "4rem" }}
                  />
                </div>
              </div>
            </div>

            {/* Total Funcionários */}
            <div className="col-4 col-md-3">
              <div className="card" style={{ width: "14rem" }}>
                <div className="card-body">
                  <h5 className="card-title">Total Funcionários</h5>
                  <p
                    className="card-text"
                    style={{ fontSize: "1.7rem", fontWeight: "bold" }}
                  >
                    18
                  </p>
                </div>
              </div>
            </div>

            {/* Ausentes */}
            <div className="col-4 col-md-3">
              <div className="card" style={{ width: "14rem" }}>
                <div className="card-body">
                  <h5 className="card-title">Ausências</h5>
                  <p
                    className="card-text"
                    style={{ fontSize: "1.7rem", fontWeight: "bold" }}
                  >
                    8
                  </p>
                </div>
              </div>
            </div>

            {/* Ao Serviço */}
            <div className="col-4 col-md-3">
              <div className="card" style={{ width: "14rem" }}>
                <div className="card-body">
                  <h5 className="card-title">Ao Serviço</h5>
                  <p
                    className="card-text"
                    style={{ fontSize: "1.7rem", fontWeight: "bold" }}
                  >
                    10
                  </p>
                </div>
              </div>
            </div>

            {/* Arrow Right */}
            <div className="col-auto d-flex align-items-center">
              <div
                className="card"
                style={{
                  width: "50%",
                  height: "80%",
                  backgroundColor: "#0E46A3",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body d-flex justify-content-center align-items-center">
                  <img
                    src={ArrowRight}
                    alt="Arrow Right"
                    style={{ width: "1.5rem", height: "4rem" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card border-0 rounded h-100">
            <div className="card-body d-flex flex-column justify-content-between overflow-auto">
              <h5 className="card-title d-flex justify-content-between align-items-center">
                Pedidos de Ausência
                <button className="btn text-white p-0 ms-auto">Ver Tudo</button>
              </h5>

              <div className="text-white" style={{ marginTop: "-15px" }}>
                <hr />
              </div>

              <ul style={{ paddingLeft: 0 }}>
                {pedidos.map((pedido, index) => (
                  <li key={index} style={{ listStyleType: "none" }}>
                    <div className="card mb-2">
                      <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                          <span
                            className="notification-ball"
                            style={{
                              height: "10px",
                              width: "10px",
                              backgroundColor: "#8a2be2",
                              borderRadius: "50%",
                              display: "inline-block",
                              marginRight: "10px",
                            }}
                          ></span>
                          <h5
                            className="card-title mb-0"
                            style={{
                              color: "white",
                              fontSize: "1rem",
                              fontWeight: "bold",
                            }}
                          >
                            {pedido}
                          </h5>
                        </div>
                        <h6 className="card-subtitle mb-0">Férias</h6>
                      </div>
                      <p
                        className="card-text mt-2"
                        style={{ color: "white", fontSize: "0.9rem" }}
                      >
                        {pedido} pediu ausência de dia 5 a 12 de fevereiro
                      </p>
                      <button
                        className="btn justify-content-between d-flex"
                        style={{ color: "#8a2be2", fontSize: "0.9rem" }}
                      >
                        Visualizar
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-2" style={{ height: "100%" }}>
        <div className="col-12 col-md-8" style={{ height: "100%" }}>
          <div
            className="card border-0 shadow-sm rounded"
            style={{ height: "100%" }}
          >
            <div
              className="card-body d-flex flex-column flex-md-row text-white"
              style={{ height: "100%" }}
            >
              <div
                className="flex-grow-1 mb-3 mb-md-0"
                style={{ height: "100%" }}
              >
                <h5 className="card-title fw-bold mb-4">
                  Pedido de Ausência de
                </h5>
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={SimaoPhoto}
                    alt="Simao Ferreira"
                    className="rounded-circle me-3"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <h6 className="mb-0 fw-bold">Simão Ferreira</h6>
                    <small className="text-white">Programador</small>
                  </div>
                </div>
                <div className="mb-3">
                  <div>
                    <span className="text-white small">Razão</span>
                    <p className="mb-0 fw-semibold">Férias</p>
                  </div>
                  <div className="d-flex flex-wrap" style={{ gap: "10rem" }}>
                    <div>
                      <span className="text-white small">Data de Início</span>
                      <p className="mb-0 fw-semibold">17/05/2025</p>
                    </div>
                    <div>
                      <span className="text-white small">Data de Fim</span>
                      <p className="mb-0 fw-semibold">26/05/2025</p>
                    </div>
                  </div>
                </div>
                <div>
                  <span className="text-white small">Descrição</span>
                  <p className="mb-0 fw-semibold">
                    Quero tirar férias porque vou com a filharmónica à Alemanha.
                  </p>
                </div>
              </div>
              <div
                className="ms-md-3"
                style={{ maxWidth: "500px", flexShrink: 0, height: "100%" }}
              >
                <img
                  src={calendarphoto}
                  alt="Imagem do lado direito"
                  className="img-fluid rounded"
                  style={{ maxHeight: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-12 col-md-8">
          <div
            className="card border-0 shadow-sm rounded"
            style={{ height: "auto" }}
          >
            <div className="card-body d-flex flex-column text-white">
              <h5 className="card-title d-flex justify-content-between align-items-center">
                Ausências dos Funcionário
                <button className="btn text-white p-0 ms-auto">Ver Tudo</button>
              </h5>
              <div className="table-responsive">
                <table className="table table-bordered table-custom-bg">
                  <thead>
                    <tr className="text-center">
                      <th scope="col">Nome Funcionário</th>
                      <th scope="col">Data de Início</th>
                      <th scope="col">Data de Fim</th>
                      <th scope="col">Detalhes</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <th
                        scope="row"
                        className="d-flex align-items-center justify-content-center"
                      >
                        <img
                          src={SimaoPhoto}
                          alt="Simao Ferreira"
                          className="rounded-circle me-3"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            objectFit: "cover",
                          }}
                        />
                        Paulo Bettencourt
                      </th>
                      <td>07/02/2025</td>
                      <td>14/02/2025</td>
                      <td>
                        <button className="btn btn-danger" type="submit">
                          Recusado
                        </button>
                      </td>
                      <td>
                        <button className="btn btn-primary" type="submit">
                          Ver Detalhes
                        </button>
                      </td>
                    </tr>
                    <tr className="text-center">
                      <th
                        scope="row"
                        className="d-flex align-items-center justify-content-center"
                      >
                        <img
                          src={SimaoPhoto}
                          alt="Simao Ferreira"
                          className="rounded-circle me-3"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            objectFit: "cover",
                          }}
                        />
                        Rodrigo Mendes
                      </th>
                      <td>05/03/2025</td>
                      <td>05/04/2025</td>
                      <td>
                        <button className="btn btn-success" type="submit">
                          Aceite
                        </button>
                      </td>
                      <td>
                        <button className="btn btn-primary" type="submit">
                          Ver Detalhes
                        </button>
                      </td>
                    </tr>
                    <tr className="text-center">
                      <th
                        scope="row"
                        className="d-flex align-items-center justify-content-center"
                      >
                        <img
                          src={SimaoPhoto}
                          alt="Simao Ferreira"
                          className="rounded-circle me-3"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            objectFit: "cover",
                          }}
                        />
                        Jorge Santos
                      </th>
                      <td>05/04/2025</td>
                      <td>14/04/2025</td>
                      <td>
                        <button className="btn btn-warning" type="submit">
                          Pendente
                        </button>
                      </td>
                      <td>
                        <button className="btn btn-primary" type="submit">
                          Ver Detalhes
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbsenceAdmin;
